import {layoutActions} from 'features/layout/redux';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {IDialogProps} from 'features/layout/redux/types';
import {call, put} from 'redux-saga/effects';
import {takeDialogResult} from './takeDialogResult';

export function* openDialogWithResult<T>(props: IDialogProps) {
   yield put(layoutActions.openSubDialog(props));
   const result: ICloseSubDialogAction<T> = yield call(takeDialogResult, props.id);

   return result;
}
